import { ToastController } from '@ionic/angular';
import { FixedPoints } from './dataClasses/FixedPoints';
import MainScene from 'src/app/Scenes/MainScene';
import eventsCenter from './EventsCenter';
import { GlobalService } from 'src/app/services/global.service';
import { Inventory } from './UI/Inventory';

export class LatLonToXYConverter {
  // Tether to MainScene
  static scene: MainScene;

  // Account for downsampling
  static downsampling_factor = 2;

  // Upper left corner coordinate
  static tj = FixedPoints.thomasJeffersonHighSchool;
  static rl = FixedPoints.rocketsLandingMarina;

  static p0 = {
    scrX: LatLonToXYConverter.tj.pixCoord.x / LatLonToXYConverter.downsampling_factor, // Minimum X position on screen
    scrY: LatLonToXYConverter.tj.pixCoord.y / LatLonToXYConverter.downsampling_factor, // Minimum Y position on screen
    lat: LatLonToXYConverter.tj.lat, // Latitude
    lng: LatLonToXYConverter.tj.lon, // Longitude
    pos: {
      x: 0,
      y: 0,
    },
  };

  // Rockets landing reference point
  static p1 = {
    scrX: LatLonToXYConverter.rl.pixCoord.x / LatLonToXYConverter.downsampling_factor, // Minimum X position on screen
    scrY: LatLonToXYConverter.rl.pixCoord.y / LatLonToXYConverter.downsampling_factor, // Minimum Y position on screen
    lat: LatLonToXYConverter.rl.lat, // Latitude
    lng: LatLonToXYConverter.rl.lon, // Longitude
    pos: {
      x: 0,
      y: 0,
    },
  };

  static radius = 6371; //Earth Radius in Km

  static setScene(scene: MainScene){
    // Tether to main scene
    LatLonToXYConverter.scene = scene;
    // Calculate global X and Y for top-left reference point
    LatLonToXYConverter.p0.pos = LatLonToXYConverter.latlngToGlobalXY(LatLonToXYConverter.p0.lat, LatLonToXYConverter.p0.lng);
    // Calculate global X and Y for bottom-right reference point
    LatLonToXYConverter.p1.pos = LatLonToXYConverter.latlngToGlobalXY(LatLonToXYConverter.p1.lat, LatLonToXYConverter.p1.lng);

    // Add listener for selecting a place to jump to
    eventsCenter.on('placeSelected', LatLonToXYConverter.goToPlace, LatLonToXYConverter);
  }

  //## Now I can calculate the global X and Y for each reference point ##\\

  // This function converts lat and lng coordinates to GLOBAL X and Y positions
  static latlngToGlobalXY(lat, lng) {
    //Calculates x based on cos of average of the latitudes
    let x = LatLonToXYConverter.radius * lng * Math.cos((LatLonToXYConverter.p0.lat + LatLonToXYConverter.p1.lat) / 2);
    //Calculates y based on latitude
    let y = LatLonToXYConverter.radius * lat;
    return { x: x, y: y, perX: 0, perY: 0 };
  }

  /*
   * This gives me the X and Y in relation to map for the 2 reference points.
   * Now we have the global AND screen areas and then we can relate both for the projection point.
   */

  // This function converts lat and lng coordinates to SCREEN X and Y positions
  static latlngToScreenXY(lat, lng): Phaser.Geom.Point {
    //Calculate global X and Y for projection point
    let pos = LatLonToXYConverter.latlngToGlobalXY(lat, lng);
    //Calculate the percentage of Global X position in relation to total global width
    pos.perX = (pos.x - LatLonToXYConverter.p0.pos.x) / (LatLonToXYConverter.p1.pos.x - LatLonToXYConverter.p0.pos.x);
    //Calculate the percentage of Global Y position in relation to total global height
    pos.perY = (pos.y - LatLonToXYConverter.p0.pos.y) / (LatLonToXYConverter.p1.pos.y - LatLonToXYConverter.p0.pos.y);

    //Returns the screen position based on reference points
    return new Phaser.Geom.Point((LatLonToXYConverter.p0.scrX + (LatLonToXYConverter.p1.scrX - LatLonToXYConverter.p0.scrX) * pos.perX)*MainScene.tileWidth, (LatLonToXYConverter.p0.scrY + (LatLonToXYConverter.p1.scrY - LatLonToXYConverter.p0.scrY) * pos.perY)*MainScene.tileHeight);
  }

  static jumpToLatLon(lat: number, lon: number) {
    console.log(`Lat: ${lat}, Lon: ${lon}`);
    var { x, y }: { x: number; y: number } = LatLonToXYConverter.latlngToScreenXY(lat, lon);
    console.log(`jumping to tile coord: x=${x}, y=${y}`);

    if(MainScene.gpsMode.isConnected){
      LatLonToXYConverter.scene.player.gpsX = x;
      LatLonToXYConverter.scene.player.gpsY = y;
    }
    else{
      LatLonToXYConverter.scene.player.x = x;
      LatLonToXYConverter.scene.player.y = y;
    }
  }

  static goToPosition(geoPosition, tween=false) {
    // If tweening (for gps mode), dont use an offset
    const offset = tween ? 0 : 0.0001;
    LatLonToXYConverter.jumpToLatLon(
      geoPosition.coords.latitude + offset,
      geoPosition.coords.longitude + offset,
    );
  }

  static async goToPlace(place) {
    if(!MainScene.gpsMode.isConnected){
      if(Inventory.getItemQuantity("mushroom") >= 3){
        LatLonToXYConverter.goToPosition(place);
        LatLonToXYConverter.scene.updateGeoPosText(place);

        // Pay for the jump with magic mushrooms
        Inventory.removeItem("mushroom", 3);

        const toast = await new ToastController().create({
          message: 'Consumed 3 magic mushrooms and teleported.',
          duration: 1500,
          color: 'success',
          position: 'top',
        });
        await toast.present();

      }
      else{
        const toast = await new ToastController().create({
          message: 'You need at least 3 magic mushrooms to teleport!',
          duration: 1500,
          color: 'warning',
          position: 'top',
        });
        await toast.present();

      }
    }
  }
}
